import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { GeneralService } from "../_services/general.service";
import { ReportsService } from "../_services/reports.service";
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ReportManager{
  private _loading: BehaviorSubject<any> = new BehaviorSubject(false);
  private _oficina: BehaviorSubject<any> = new BehaviorSubject(null);
  private _ramo: BehaviorSubject<any> = new BehaviorSubject(null);
  private _area: BehaviorSubject<any> = new BehaviorSubject(null);
  private _susc: BehaviorSubject<any> = new BehaviorSubject(null);
  private _tarea: BehaviorSubject<any> = new BehaviorSubject(null);
  private _producto: BehaviorSubject<any> = new BehaviorSubject(null);
  private _moneda: BehaviorSubject<any> = new BehaviorSubject(null);
  private _archivo: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private generalService: GeneralService,
    private reportService: ReportsService
  ) {

  }

  getLoading() {
    return this._loading.asObservable();
  }


  getListOficina() {
    return this._oficina.asObservable();
  }

  getAllOficinas() {
    this._loading.next(true);
    this.generalService.getOficinas().subscribe(rest => {
      this._loading.next(false);
      this._oficina.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListMoneda() {
    return this._moneda.asObservable();
  }

  getAllMoneda() {
    this._loading.next(true);
    this.generalService.getMoneda().subscribe(rest => {
      this._loading.next(false);
      this._moneda.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListProducto() {
    return this._producto.asObservable();
  }

  getAllProductos(area) {
    this._loading.next(true);
    this.generalService.getProducto(area).subscribe(rest => {
      this._loading.next(false);
      this._producto.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListRamos() {
    return this._ramo.asObservable();
  }

  getAllRamos(codprod) {
    this._loading.next(true);
    this.generalService.getRamo(codprod).subscribe(rest => {
      this._loading.next(false);
      this._ramo.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListAreas() {
    return this._area.asObservable();
  }

  getAllAreas(producto) {
    this._loading.next(true);
    this.generalService.getAreas(producto).subscribe(rest => {
      this._loading.next(false);
      this._area.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListTipoAreas() {
    return this._tarea.asObservable();
  }

  getAllTipoAreas() {
    this._loading.next(true);
    this.generalService.getTipoAreas().subscribe(rest => {
      this._loading.next(false);
      this._tarea.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getListTipoSusc() {
    return this._susc.asObservable();
  }

  getAllTipoSusc() {
    this._loading.next(true);
    this.generalService.getTipoSusc().subscribe(rest => {
      this._loading.next(false);
      this._susc.next(rest);
    }, err => {
        this._loading.next(false);
    });
  }

  getReport(name) {
    this._loading.next(true);
    this.reportService.getArchivo(name).subscribe((data: any) => {
      this._loading.next(false);
      var pdfResult = data;
      let pdfWindow = window.open("");
      pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
    }, err => {
        this._loading.next(false);
    });
  }


  getReportA(name) {
    this._loading.next(true);
    let postdata={report:name.report,extencion:name.extension}
    this.reportService.getArchivoA(postdata).subscribe((data: any) => {
      this._loading.next(false);
      this._archivo.next(data);
      /*var pdfResult = data;
      let pdfWindow = window.open("");
      pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");*/
    }, err => {
        this._loading.next(false);
    });
  }

  submitARC(from,until,tipoid,numid){
    this._loading.next(true);
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="ARC";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{P_FECDESDE:from},{P_FECHASTA:until},{P_TIPOTER:'AC'},{P_TIPOID:tipoid},{P_NUMID:numid}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    })
  }

  submitReferencer(dirigido){
    this._loading.next(true);
    let report="REFECOME";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{NCODINTER:codinter},{P_DESTINATARIO:dirigido}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    })
  }

  //SUBMITS
  submitPrinCob(from, until, ejecutivo, oficina, tipoInter = false){ 

    if(tipoInter){

      this._loading.next(true);
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="PRIMACOBRADAINTER";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    // {P_AREA: area}, {P_EJECUTIVO: ejecutivo}, {P_FEC_DESDE: until}, {P_FEC_HASTA: from}, {P_OFICINA: oficina}, {P_POLIZA: poliza}, {P_PRODUCTO: producto}, {P_PRODUCTOR: productor}, {P_RAMO: ramo}, {P_TIPOAREA: tipoarea}, {P_TIPOSUSC: tiposusc}
    
    let valor =[{P_INICIO:from}, {P_FIN:until}, {P_CODINTER:codinter}, {p_EJECUTIVO: ejecutivo}, {p_OFICINA: oficina}]

    // + let valor=[{P_AREA: 'TODO'}, {P_EJECUTIVO: ejecutivo}, {P_FEC_DESDE: until}, {P_FEC_HASTA: from}, {P_OFICINA: oficina}, {P_PRODUCTO: '0'}, {P_PRODUCTOR: codinter}, {P_RAMO: '0'}, {P_TIPOAREA: '0'}];

    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    })

    } else {

      this._loading.next(true);
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="PRIMACOBRAEV"; // PRIMACOBRADA -> ANTES
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    // {P_AREA: area}, {P_EJECUTIVO: ejecutivo}, {P_FEC_DESDE: until}, {P_FEC_HASTA: from}, {P_OFICINA: oficina}, {P_POLIZA: poliza}, {P_PRODUCTO: producto}, {P_PRODUCTOR: productor}, {P_RAMO: ramo}, {P_TIPOAREA: tipoarea}, {P_TIPOSUSC: tiposusc}
    
    let valor =[{P_INICIO:from}, {P_FIN:until}, {P_CODINTER:codinter}, {P_CODUSR: ejecutivo}, {P_CODOFI: oficina}] // P_EJECUTIVO & P_OFICINA -> P_CODUSR & P_CODOFI

    // + let valor=[{P_AREA: 'TODO'}, {P_EJECUTIVO: ejecutivo}, {P_FEC_DESDE: until}, {P_FEC_HASTA: from}, {P_OFICINA: oficina}, {P_PRODUCTO: '0'}, {P_PRODUCTOR: codinter}, {P_RAMO: '0'}, {P_TIPOAREA: '0'}];

    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    })

    }

    
  }


//NO SE ENCUENTRA EN EL SERVIDOR
  submitPrimDev(oficina,ramo,moneda,from,until){
    this._loading.next(true);
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="REDEVDIA";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{P_OFICINA:oficina},{P_FECHA_DESDE:from},{P_FECHA_HASTA:until},{P_MONEDA:moneda},
      {P_RAMO:ramo},{P_PRODUCTOR:codinter}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  submitPrimPen(oficina,susc,moneda,area,until,poliza,producto){
    this._loading.next(true);
    until=moment(until).format('DD/MM/YYYY');
    let report="REPINTFA";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{P_OFICINA:oficina},{P_SUBSTSFIAN:'0'},,{P_AREA:area},{P_FEC_HASTA:until},{P_MONEDA:moneda},
    {P_TIPOSUSC:susc},{P_POLIZA:poliza},{P_PRODUCTO:producto},{P_CODINTER:codinter}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  submitPrimEmi(oficina,ramo,moneda,from,until){
    this._loading.next(true);
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="REPEMIRF";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{P_OFICINA:oficina},{P_FECHA_DESDE:from}, {P_FECHA_HASTA:until},{P_MONEDA:moneda},{P_RAMO:ramo},
      {P_ESTADO:'TODOS'},{P_PRODUCTOR:codinter}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  submitPrinRen(oficina,producto,moneda,area,from,until){
    this._loading.next(true);
    let mes;//=from.getMonth();
    mes=moment(from).format('MM');
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="LISRENOV";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    console.log(oficina);
    let valor=[{P_AREA:area},{P_OFICINA:oficina},{P_FEC_DESDE:from},{P_FECHA:until},{P_PRODUCTO:producto},
      {P_MONEDA:moneda},{P_MES:mes},{P_INTERMEDIARIO:codinter}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(rest=>{
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  submitPreRen(oficina,producto,moneda,area,from,until){
    this._loading.next(true);
    let mes;
    mes=moment(from).format('MM');
    from=moment(from).format('DD/MM/YYYY');
    until=moment(until).format('DD/MM/YYYY');
    let report="PRERENOV";
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let valor=[{P_AREA:area},{P_OFICINA:oficina},{P_FEC_DESDE:from},{P_FECHA:until},{P_PRODUCTO:producto},
      {P_MONEDA:moneda},{P_MES:mes},{P_INTERMEDIARIO:codinter}];
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(response => {
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  //  V. VIEJA
  anexo(valor, nombre){
    this._loading.next(true);
    let report=nombre;
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    this.reportService.getReports(postdata).subscribe(response => {
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

  //   anexo(valor,nombre){
  //   this._loading.next(true);
  //   let report=nombre;
  //   let variable=JSON.parse(localStorage.getItem("currentUser"));
  //   let codinter= variable.codinter;
  //   let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
  //   this.reportService.getReports(postdata).subscribe(response => {
  //     this._loading.next(false);
  //     this.reportService.getArchivo(report).subscribe((data: any)=>{
  //       this._loading.next(false);
  //       var pdfResult = data;
  //       let pdfWindow = window.open("");
  //       pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
  //     },err =>{
  //       this._loading.next(false);
  //     });
  //   },err =>{
  //     this._loading.next(false);
  //   });
  // }

  anexopol(idepol){
    this._loading.next(true);
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let postdata ={codinter:codinter,idepol: idepol,numcert: 1};
    this.reportService.getAnexo(postdata).subscribe((rest:any) => {
      this._loading.next(false);
      var pdfResult = rest;
      let pdfWindow = window.open("");
      pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      //window.open('data:application/pdf;base64,' + rest);
    }, err => {
        this._loading.next(false);

    });
  }

   carnet(idepol){
    this._loading.next(true);
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let postdata ={codinter:codinter,idepol: idepol};
    this.reportService.getCarnet(postdata).subscribe((rest:any) => {
      this._loading.next(false);
      var pdfResult = rest;
      let pdfWindow = window.open("");
      pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      //window.open('data:application/pdf;base64,' + rest);
    }, err => {
        this._loading.next(false);

    });
  }

  // FIN V. VIEJA

  // V. VIEJA
  // recibo(valor,nombre){
  //   this._loading.next(true);
  //   let report=nombre;
  //   let variable=JSON.parse(localStorage.getItem("currentUser"));
  //   let codinter= variable.codinter;
  //   let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
  //   this.reportService.getReports(postdata).subscribe(response => {
  //     this._loading.next(false);
  //     this.reportService.getArchivo(report).subscribe((data: any)=>{
  //       this._loading.next(false);
  //       //window.open('data:application/pdf;base64,' + data);
  //       var pdfResult = data;
  //       let pdfWindow = window.open("");
  //       pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
  //     },err =>{
  //       this._loading.next(false);
  //     });
  //   },err =>{
  //     this._loading.next(false);
  //   });
  // }

  recibo(valor,nombre){
    this._loading.next(true);
    let report=nombre;
    let variable=JSON.parse(localStorage.getItem("currentUser"));
    let codinter= variable.codinter;
    let postdata ={codinter:codinter,report:report,nombre:report,valor:valor};
    
    // console.log('postdata a enviar a getReports:', postdata); // prueba:

    this.reportService.getReports(postdata).subscribe(response => {
      
      // console.log('getReports() response:', response); // prueba:
      this._loading.next(false);
      this.reportService.getArchivo(report).subscribe((data: any)=>{
        this._loading.next(false);
        //window.open('data:application/pdf;base64,' + data);
        var pdfResult = data;
        let pdfWindow = window.open("");
        pdfWindow.document.write("<body style='margin: 0; overflow: hidden'><iframe style='border: none' width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe></body>");
      },err =>{
        this._loading.next(false);
      });
    },err =>{
      this._loading.next(false);
    });
  }

}
